import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from '@angular/cdk/layout';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../../shared/shared.module';
import { PublicLayoutComponent } from './layout/public-layout/public-layout.component';
import { ContactComponent } from './pages/contact/contact.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { ProductDetailComponent } from './pages/product-detail/product-detail.component';
import { SubscriptionComponent } from './pages/subscription/subscription.component';
import { SubscriptionInsuredComponent } from './pages/subscription/subscription-insured/subscription-insured.component';
import { SubscriptionBankDetailsComponent } from './pages/subscription/subscription-bank-details/subscription-bank-details.component';
import { SubscriptionPaymentComponent } from './pages/subscription/subscription-payment/subscription-payment.component';
import { DevisComponent } from './pages/devis/devis.component';
import { MySpaceComponent } from './pages/my-space/my-space.component';
import { PolicyClaimFormComponent } from './pages/my-space/policy-claim-form/policy-claim-form.component';
import { HistoryComponent } from './pages/history/history.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';

@NgModule({
  declarations: [
    PublicLayoutComponent,
    ContactComponent,
    LoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    ProfileComponent,
    ProductDetailComponent,
    SubscriptionComponent,
    SubscriptionInsuredComponent,
    SubscriptionBankDetailsComponent,
    SubscriptionPaymentComponent,
    NotificationsComponent,
    DevisComponent,
    MySpaceComponent,
    PolicyClaimFormComponent,
    HistoryComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    ReactiveFormsModule,
    LayoutModule,
    MatTabsModule,
  ],
})
export class PublicModule {}
